import React from 'react';
import { ToggleButton, ToggleButtonGroup, Box, Typography } from '@mui/material';
import { Person, PersonOutline } from '@mui/icons-material';

/**
 * GenderSelector component for the Wellness AI web app
 * Allows users to select between male and female wellness rep characters
 */
const GenderSelector = ({ selectedGender, onGenderChange }) => {
  return (
    <Box sx={{ 
      display: 'flex', 
      flexDirection: 'column', 
      alignItems: 'center',
      gap: 1 
    }}>
      <ToggleButtonGroup
        value={selectedGender}
        exclusive
        onChange={(event, newGender) => {
          if (newGender !== null) {
            onGenderChange(newGender);
          }
        }}
        aria-label="wellness rep gender selection"
        size="small"
        sx={{
          bgcolor: 'rgba(255, 255, 255, 0.1)',
          borderRadius: 2,
          padding: '2px',
          border: '1px solid rgba(255, 255, 255, 0.2)',
          '& .MuiToggleButton-root': {
            color: 'rgba(255, 255, 255, 0.7)',
            border: 'none',
            fontSize: { xs: '0.75rem', sm: '0.8rem' },
            fontWeight: 500,
            px: { xs: 1, sm: 1.5 },
            py: { xs: 0.3, sm: 0.5 },
            borderRadius: 1.5,
            minWidth: { xs: 50, sm: 60 },
            transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
            textTransform: 'capitalize',
            '&.Mui-selected': {
              bgcolor: 'rgba(255, 255, 255, 0.9)',
              color: '#1976d2',
              fontWeight: 600,
              boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
              transform: 'translateY(-1px)',
              '&:hover': {
                bgcolor: 'rgba(255, 255, 255, 0.95)',
                transform: 'translateY(-1px)',
              },
            },
            '&:hover': {
              bgcolor: 'rgba(255, 255, 255, 0.15)',
              color: 'rgba(255, 255, 255, 0.9)',
            },
          },
        }}
      >
        <ToggleButton 
          value="male" 
          aria-label="Select male wellness rep"
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 0.5
          }}
        >
          <Person sx={{ fontSize: { xs: 14, sm: 16 } }} />
          Male
        </ToggleButton>
        <ToggleButton 
          value="female" 
          aria-label="Select female wellness rep"
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 0.5
          }}
        >
          <PersonOutline sx={{ fontSize: { xs: 14, sm: 16 } }} />
          Female
        </ToggleButton>
      </ToggleButtonGroup>
    </Box>
  );
};

export default GenderSelector;
